/* eslint-disable */
import * as $protobuf from 'protobufjs/minimal';

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots['dealer.busi.ws'] || ($protobuf.roots['dealer.busi.ws'] = {});

export const eventpackage = $root.eventpackage = (() => {

    /**
     * Namespace eventpackage.
     * @exports eventpackage
     * @namespace
     */
    const eventpackage = {};

    eventpackage.EventData = (function () {

        /**
         * Properties of an EventData.
         * @memberof eventpackage
         * @interface IEventData
         * @property {string} id EventData id
         * @property {string} methodName EventData methodName
         * @property {Array.<eventpackage.ITypeValue>|null} [args] EventData args
         */

        /**
         * Constructs a new EventData.
         * @memberof eventpackage
         * @classdesc Represents an EventData.
         * @implements IEventData
         * @constructor
         * @param {eventpackage.IEventData=} [properties] Properties to set
         */
        function EventData (properties) {
            this.args = [];
            if (properties) {
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i) {
                    if (properties[keys[i]] != null) { this[keys[i]] = properties[keys[i]]; }
                }
            }
        }

        /**
         * EventData id.
         * @member {string} id
         * @memberof eventpackage.EventData
         * @instance
         */
        EventData.prototype.id = '';

        /**
         * EventData methodName.
         * @member {string} methodName
         * @memberof eventpackage.EventData
         * @instance
         */
        EventData.prototype.methodName = '';

        /**
         * EventData args.
         * @member {Array.<eventpackage.ITypeValue>} args
         * @memberof eventpackage.EventData
         * @instance
         */
        EventData.prototype.args = $util.emptyArray;

        /**
         * Creates a new EventData instance using the specified properties.
         * @function create
         * @memberof eventpackage.EventData
         * @static
         * @param {eventpackage.IEventData=} [properties] Properties to set
         * @returns {eventpackage.EventData} EventData instance
         */
        EventData.create = function create (properties) {
            return new EventData(properties);
        };

        /**
         * Encodes the specified EventData message. Does not implicitly {@link eventpackage.EventData.verify|verify} messages.
         * @function encode
         * @memberof eventpackage.EventData
         * @static
         * @param {eventpackage.IEventData} message EventData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EventData.encode = function encode (message, writer) {
            if (!writer) { writer = $Writer.create(); }
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.methodName);
            if (message.args != null && message.args.length) {
                for (let i = 0; i < message.args.length; ++i) { $root.eventpackage.TypeValue.encode(message.args[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim(); }
            }
            return writer;
        };

        /**
         * Encodes the specified EventData message, length delimited. Does not implicitly {@link eventpackage.EventData.verify|verify} messages.
         * @function encodeDelimited
         * @memberof eventpackage.EventData
         * @static
         * @param {eventpackage.IEventData} message EventData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EventData.encodeDelimited = function encodeDelimited (message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EventData message from the specified reader or buffer.
         * @function decode
         * @memberof eventpackage.EventData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {eventpackage.EventData} EventData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EventData.decode = function decode (reader, length) {
            if (!(reader instanceof $Reader)) { reader = $Reader.create(reader); }
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.eventpackage.EventData();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                    case 1:
                        message.id = reader.string();
                        break;
                    case 2:
                        message.methodName = reader.string();
                        break;
                    case 3:
                        if (!(message.args && message.args.length)) { message.args = []; }
                        message.args.push($root.eventpackage.TypeValue.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            if (!message.hasOwnProperty('id')) { throw $util.ProtocolError('missing required \'id\'', { instance: message }); }
            if (!message.hasOwnProperty('methodName')) { throw $util.ProtocolError('missing required \'methodName\'', { instance: message }); }
            return message;
        };

        /**
         * Decodes an EventData message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof eventpackage.EventData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {eventpackage.EventData} EventData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EventData.decodeDelimited = function decodeDelimited (reader) {
            if (!(reader instanceof $Reader)) { reader = new $Reader(reader); }
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EventData message.
         * @function verify
         * @memberof eventpackage.EventData
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EventData.verify = function verify (message) {
            if (typeof message !== 'object' || message === null) { return 'object expected'; }
            if (!$util.isString(message.id)) { return 'id: string expected'; }
            if (!$util.isString(message.methodName)) { return 'methodName: string expected'; }
            if (message.args != null && message.hasOwnProperty('args')) {
                if (!Array.isArray(message.args)) { return 'args: array expected'; }
                for (let i = 0; i < message.args.length; ++i) {
                    let error = $root.eventpackage.TypeValue.verify(message.args[i]);
                    if (error) { return 'args.' + error; }
                }
            }
            return null;
        };

        /**
         * Creates an EventData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof eventpackage.EventData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {eventpackage.EventData} EventData
         */
        EventData.fromObject = function fromObject (object) {
            if (object instanceof $root.eventpackage.EventData) { return object; }
            let message = new $root.eventpackage.EventData();
            if (object.id != null) { message.id = String(object.id); }
            if (object.methodName != null) { message.methodName = String(object.methodName); }
            if (object.args) {
                if (!Array.isArray(object.args)) { throw TypeError('.eventpackage.EventData.args: array expected'); }
                message.args = [];
                for (let i = 0; i < object.args.length; ++i) {
                    if (typeof object.args[i] !== 'object') { throw TypeError('.eventpackage.EventData.args: object expected'); }
                    message.args[i] = $root.eventpackage.TypeValue.fromObject(object.args[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an EventData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof eventpackage.EventData
         * @static
         * @param {eventpackage.EventData} message EventData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EventData.toObject = function toObject (message, options) {
            if (!options) { options = {}; }
            let object = {};
            if (options.arrays || options.defaults) { object.args = []; }
            if (options.defaults) {
                object.id = '';
                object.methodName = '';
            }
            if (message.id != null && message.hasOwnProperty('id')) { object.id = message.id; }
            if (message.methodName != null && message.hasOwnProperty('methodName')) { object.methodName = message.methodName; }
            if (message.args && message.args.length) {
                object.args = [];
                for (let j = 0; j < message.args.length; ++j) { object.args[j] = $root.eventpackage.TypeValue.toObject(message.args[j], options); }
            }
            return object;
        };

        /**
         * Converts this EventData to JSON.
         * @function toJSON
         * @memberof eventpackage.EventData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EventData.prototype.toJSON = function toJSON () {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EventData;
    })();

    eventpackage.TypeValue = (function () {

        /**
         * Properties of a TypeValue.
         * @memberof eventpackage
         * @interface ITypeValue
         * @property {number|null} [type] TypeValue type
         * @property {string|null} [value] TypeValue value
         */

        /**
         * Constructs a new TypeValue.
         * @memberof eventpackage
         * @classdesc Represents a TypeValue.
         * @implements ITypeValue
         * @constructor
         * @param {eventpackage.ITypeValue=} [properties] Properties to set
         */
        function TypeValue (properties) {
            if (properties) {
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i) {
                    if (properties[keys[i]] != null) { this[keys[i]] = properties[keys[i]]; }
                }
            }
        }

        /**
         * TypeValue type.
         * @member {number} type
         * @memberof eventpackage.TypeValue
         * @instance
         */
        TypeValue.prototype.type = 0;

        /**
         * TypeValue value.
         * @member {string} value
         * @memberof eventpackage.TypeValue
         * @instance
         */
        TypeValue.prototype.value = '';

        /**
         * Creates a new TypeValue instance using the specified properties.
         * @function create
         * @memberof eventpackage.TypeValue
         * @static
         * @param {eventpackage.ITypeValue=} [properties] Properties to set
         * @returns {eventpackage.TypeValue} TypeValue instance
         */
        TypeValue.create = function create (properties) {
            return new TypeValue(properties);
        };

        /**
         * Encodes the specified TypeValue message. Does not implicitly {@link eventpackage.TypeValue.verify|verify} messages.
         * @function encode
         * @memberof eventpackage.TypeValue
         * @static
         * @param {eventpackage.ITypeValue} message TypeValue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TypeValue.encode = function encode (message, writer) {
            if (!writer) { writer = $Writer.create(); }
            if (message.type != null && Object.hasOwnProperty.call(message, 'type')) { writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type); }
            if (message.value != null && Object.hasOwnProperty.call(message, 'value')) { writer.uint32(/* id 2, wireType 2 =*/18).string(message.value); }
            return writer;
        };

        /**
         * Encodes the specified TypeValue message, length delimited. Does not implicitly {@link eventpackage.TypeValue.verify|verify} messages.
         * @function encodeDelimited
         * @memberof eventpackage.TypeValue
         * @static
         * @param {eventpackage.ITypeValue} message TypeValue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TypeValue.encodeDelimited = function encodeDelimited (message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TypeValue message from the specified reader or buffer.
         * @function decode
         * @memberof eventpackage.TypeValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {eventpackage.TypeValue} TypeValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TypeValue.decode = function decode (reader, length) {
            if (!(reader instanceof $Reader)) { reader = $Reader.create(reader); }
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.eventpackage.TypeValue();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                    case 1:
                        message.type = reader.int32();
                        break;
                    case 2:
                        message.value = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };

        /**
         * Decodes a TypeValue message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof eventpackage.TypeValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {eventpackage.TypeValue} TypeValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TypeValue.decodeDelimited = function decodeDelimited (reader) {
            if (!(reader instanceof $Reader)) { reader = new $Reader(reader); }
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TypeValue message.
         * @function verify
         * @memberof eventpackage.TypeValue
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TypeValue.verify = function verify (message) {
            if (typeof message !== 'object' || message === null) { return 'object expected'; }
            if (message.type != null && message.hasOwnProperty('type')) {
                if (!$util.isInteger(message.type)) { return 'type: integer expected'; }
            }
            if (message.value != null && message.hasOwnProperty('value')) {
                if (!$util.isString(message.value)) { return 'value: string expected'; }
            }
            return null;
        };

        /**
         * Creates a TypeValue message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof eventpackage.TypeValue
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {eventpackage.TypeValue} TypeValue
         */
        TypeValue.fromObject = function fromObject (object) {
            if (object instanceof $root.eventpackage.TypeValue) { return object; }
            let message = new $root.eventpackage.TypeValue();
            if (object.type != null) { message.type = object.type | 0; }
            if (object.value != null) { message.value = String(object.value); }
            return message;
        };

        /**
         * Creates a plain object from a TypeValue message. Also converts values to other types if specified.
         * @function toObject
         * @memberof eventpackage.TypeValue
         * @static
         * @param {eventpackage.TypeValue} message TypeValue
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TypeValue.toObject = function toObject (message, options) {
            if (!options) { options = {}; }
            let object = {};
            if (options.defaults) {
                object.type = 0;
                object.value = '';
            }
            if (message.type != null && message.hasOwnProperty('type')) { object.type = message.type; }
            if (message.value != null && message.hasOwnProperty('value')) { object.value = message.value; }
            return object;
        };

        /**
         * Converts this TypeValue to JSON.
         * @function toJSON
         * @memberof eventpackage.TypeValue
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TypeValue.prototype.toJSON = function toJSON () {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TypeValue;
    })();

    eventpackage.EventMessage = (function () {

        /**
         * Properties of an EventMessage.
         * @memberof eventpackage
         * @interface IEventMessage
         * @property {number|Long} msgId EventMessage msgId
         * @property {eventpackage.IEventData} data EventMessage data
         * @property {string|null} [fromUserId] EventMessage fromUserId
         * @property {string|null} [toUserId] EventMessage toUserId
         */

        /**
         * Constructs a new EventMessage.
         * @memberof eventpackage
         * @classdesc Represents an EventMessage.
         * @implements IEventMessage
         * @constructor
         * @param {eventpackage.IEventMessage=} [properties] Properties to set
         */
        function EventMessage (properties) {
            if (properties) {
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i) {
                    if (properties[keys[i]] != null) { this[keys[i]] = properties[keys[i]]; }
                }
            }
        }

        /**
         * EventMessage msgId.
         * @member {number|Long} msgId
         * @memberof eventpackage.EventMessage
         * @instance
         */
        EventMessage.prototype.msgId = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

        /**
         * EventMessage data.
         * @member {eventpackage.IEventData} data
         * @memberof eventpackage.EventMessage
         * @instance
         */
        EventMessage.prototype.data = null;

        /**
         * EventMessage fromUserId.
         * @member {string|null|undefined} fromUserId
         * @memberof eventpackage.EventMessage
         * @instance
         */
        EventMessage.prototype.fromUserId = null;

        /**
         * EventMessage toUserId.
         * @member {string|null|undefined} toUserId
         * @memberof eventpackage.EventMessage
         * @instance
         */
        EventMessage.prototype.toUserId = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * EventMessage _fromUserId.
         * @member {"fromUserId"|undefined} _fromUserId
         * @memberof eventpackage.EventMessage
         * @instance
         */
        Object.defineProperty(EventMessage.prototype, '_fromUserId', {
            get: $util.oneOfGetter($oneOfFields = ['fromUserId']),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * EventMessage _toUserId.
         * @member {"toUserId"|undefined} _toUserId
         * @memberof eventpackage.EventMessage
         * @instance
         */
        Object.defineProperty(EventMessage.prototype, '_toUserId', {
            get: $util.oneOfGetter($oneOfFields = ['toUserId']),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new EventMessage instance using the specified properties.
         * @function create
         * @memberof eventpackage.EventMessage
         * @static
         * @param {eventpackage.IEventMessage=} [properties] Properties to set
         * @returns {eventpackage.EventMessage} EventMessage instance
         */
        EventMessage.create = function create (properties) {
            return new EventMessage(properties);
        };

        /**
         * Encodes the specified EventMessage message. Does not implicitly {@link eventpackage.EventMessage.verify|verify} messages.
         * @function encode
         * @memberof eventpackage.EventMessage
         * @static
         * @param {eventpackage.IEventMessage} message EventMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EventMessage.encode = function encode (message, writer) {
            if (!writer) { writer = $Writer.create(); }
            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.msgId);
            $root.eventpackage.EventData.encode(message.data, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.fromUserId != null && Object.hasOwnProperty.call(message, 'fromUserId')) { writer.uint32(/* id 3, wireType 2 =*/26).string(message.fromUserId); }
            if (message.toUserId != null && Object.hasOwnProperty.call(message, 'toUserId')) { writer.uint32(/* id 4, wireType 2 =*/34).string(message.toUserId); }
            return writer;
        };

        /**
         * Encodes the specified EventMessage message, length delimited. Does not implicitly {@link eventpackage.EventMessage.verify|verify} messages.
         * @function encodeDelimited
         * @memberof eventpackage.EventMessage
         * @static
         * @param {eventpackage.IEventMessage} message EventMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EventMessage.encodeDelimited = function encodeDelimited (message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EventMessage message from the specified reader or buffer.
         * @function decode
         * @memberof eventpackage.EventMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {eventpackage.EventMessage} EventMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EventMessage.decode = function decode (reader, length) {
            if (!(reader instanceof $Reader)) { reader = $Reader.create(reader); }
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.eventpackage.EventMessage();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                    case 1:
                        message.msgId = reader.int64();
                        break;
                    case 2:
                        message.data = $root.eventpackage.EventData.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.fromUserId = reader.string();
                        break;
                    case 4:
                        message.toUserId = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            if (!message.hasOwnProperty('msgId')) { throw $util.ProtocolError('missing required \'msgId\'', { instance: message }); }
            if (!message.hasOwnProperty('data')) { throw $util.ProtocolError('missing required \'data\'', { instance: message }); }
            return message;
        };

        /**
         * Decodes an EventMessage message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof eventpackage.EventMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {eventpackage.EventMessage} EventMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EventMessage.decodeDelimited = function decodeDelimited (reader) {
            if (!(reader instanceof $Reader)) { reader = new $Reader(reader); }
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EventMessage message.
         * @function verify
         * @memberof eventpackage.EventMessage
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EventMessage.verify = function verify (message) {
            if (typeof message !== 'object' || message === null) { return 'object expected'; }
            let properties = {};
            if (!$util.isInteger(message.msgId) && !(message.msgId && $util.isInteger(message.msgId.low) && $util.isInteger(message.msgId.high))) { return 'msgId: integer|Long expected'; }
            {
                let error = $root.eventpackage.EventData.verify(message.data);
                if (error) { return 'data.' + error; }
            }
            if (message.fromUserId != null && message.hasOwnProperty('fromUserId')) {
                properties._fromUserId = 1;
                if (!$util.isString(message.fromUserId)) { return 'fromUserId: string expected'; }
            }
            if (message.toUserId != null && message.hasOwnProperty('toUserId')) {
                properties._toUserId = 1;
                if (!$util.isString(message.toUserId)) { return 'toUserId: string expected'; }
            }
            return null;
        };

        /**
         * Creates an EventMessage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof eventpackage.EventMessage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {eventpackage.EventMessage} EventMessage
         */
        EventMessage.fromObject = function fromObject (object) {
            if (object instanceof $root.eventpackage.EventMessage) { return object; }
            let message = new $root.eventpackage.EventMessage();
            if (object.msgId != null) {
                if ($util.Long) { (message.msgId = $util.Long.fromValue(object.msgId)).unsigned = false; }
                else if (typeof object.msgId === 'string') { message.msgId = parseInt(object.msgId, 10); }
                else if (typeof object.msgId === 'number') { message.msgId = object.msgId; }
                else if (typeof object.msgId === 'object') { message.msgId = new $util.LongBits(object.msgId.low >>> 0, object.msgId.high >>> 0).toNumber(); }
            }
            if (object.data != null) {
                if (typeof object.data !== 'object') { throw TypeError('.eventpackage.EventMessage.data: object expected'); }
                message.data = $root.eventpackage.EventData.fromObject(object.data);
            }
            if (object.fromUserId != null) { message.fromUserId = String(object.fromUserId); }
            if (object.toUserId != null) { message.toUserId = String(object.toUserId); }
            return message;
        };

        /**
         * Creates a plain object from an EventMessage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof eventpackage.EventMessage
         * @static
         * @param {eventpackage.EventMessage} message EventMessage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EventMessage.toObject = function toObject (message, options) {
            if (!options) { options = {}; }
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.msgId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else { object.msgId = options.longs === String ? '0' : 0; }
                object.data = null;
            }
            if (message.msgId != null && message.hasOwnProperty('msgId')) {
                if (typeof message.msgId === 'number') { object.msgId = options.longs === String ? String(message.msgId) : message.msgId; }
                else { object.msgId = options.longs === String ? $util.Long.prototype.toString.call(message.msgId) : options.longs === Number ? new $util.LongBits(message.msgId.low >>> 0, message.msgId.high >>> 0).toNumber() : message.msgId; }
            }
            if (message.data != null && message.hasOwnProperty('data')) { object.data = $root.eventpackage.EventData.toObject(message.data, options); }
            if (message.fromUserId != null && message.hasOwnProperty('fromUserId')) {
                object.fromUserId = message.fromUserId;
                if (options.oneofs) { object._fromUserId = 'fromUserId'; }
            }
            if (message.toUserId != null && message.hasOwnProperty('toUserId')) {
                object.toUserId = message.toUserId;
                if (options.oneofs) { object._toUserId = 'toUserId'; }
            }
            return object;
        };

        /**
         * Converts this EventMessage to JSON.
         * @function toJSON
         * @memberof eventpackage.EventMessage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EventMessage.prototype.toJSON = function toJSON () {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EventMessage;
    })();

    return eventpackage;
})();

export { $root as default };
